function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#A5A5A5;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M599.18,123.81c-6.83-6.63-11.71-16.68-24.02-13.7l0,0c-1.99-0.06-3.99-0.18-5.98-0.18 c-58.27,0-116.54,0.01-174.81,0.01c-58.44,0-116.88-0.01-175.31,0c-9.79,0-9.04-0.79-9.01,9.3c0.04,11.82,0.11,23.64,0.19,35.46 c0.01,2.15-0.17,4.34,0.75,6.4c0,0,0,0,0,0c0.26,24.64-0.06,49.28,0.77,73.93c0.9,26.62,0.24,53.28,1.13,79.93 c0.69,20.97-0.19,41.97,1.17,62.93c0,0,0,0,0,0c-0.14,39.47,1.05,78.91,1.68,118.37c0.65,41.13,0.97,82.26,1.48,123.38 c0.05,4.14-0.48,8.33,0.77,12.41c0.39,32.27,0.61,64.54,1.25,96.81c0.31,15.7-3.5,14.22,14.92,13.81c3.25-0.57,4.13-2.6,4.08-5.73 c-0.81-44.71-1.54-89.41-2.29-134.12c0,0,0,0,0,0c0.04-3.16,0.15-6.32,0.1-9.48c-0.93-56.22-1.9-112.45-2.81-168.67 c-0.5-30.61-0.89-61.22-1.33-91.83c0,0,0,0,0,0c0,0,0,0,0,0c0.04-2,0.13-4,0.1-5.99c-0.63-36.98-1.28-73.96-1.9-110.94 c-0.42-24.65-0.79-49.31-1.19-73.96c-0.01-1.03-0.01-2.06-0.02-3.1c0.04-1,0.16-2,0.11-2.99c-0.48-9.1-0.49-9.09,8.91-9.09 c96.79,0.03,193.58,0.06,290.37,0.09c23.16,0.01,46.31,0.03,69.47-0.03c1.13,0,2.88,0.93,3.31-0.93 C601.17,125.37,599.84,124.51,599.18,123.81z"
});

function SvgColourchangeLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 686.32 841.89",
    style: {
      enableBackground: "new 0 0 686.32 841.89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColourchangeLeft);
export default __webpack_public_path__ + "static/media/colourchange-left.38dcc7c0.svg";
export { ForwardRef as ReactComponent };